import React, { useState, useEffect } from "react";
import { getCompany_masterData, get_liveprice } from "../../ApisService/apiService";
import style from "../../../css/dashboard/fundamental/Company.module.css";

const Fundamental = ({ selectedCompany }) => {
    const [companyData, setCompanyData] = useState(null);
    const [livePrice, setLivePrice] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [openChange, setOpenChange] = useState(null);

    useEffect(() => {
        if (!selectedCompany || !selectedCompany.scripcode) {
            setCompanyData(null);
            setLivePrice(null);
            return;
        }

        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const companyResponse = await getCompany_masterData(selectedCompany.scripcode);
                setCompanyData(companyResponse?.json_data || null);

                const livePriceResponse = await get_liveprice(selectedCompany.scripcode);
                setLivePrice(livePriceResponse?.live_price || null);

                // Calculate percentage change from Open price
                if (livePriceResponse?.live_price?.CLOSE && livePriceResponse?.live_price?.OPEN) {
                    const currentPrice = livePriceResponse.live_price.CLOSE;
                    const openPrice = livePriceResponse.live_price.OPEN;
                    const percentOpenChange = ((currentPrice - openPrice) / openPrice) * 100;
                    setOpenChange(percentOpenChange.toFixed(2)); // Keeping 2 decimal places
                }
            } catch (err) {
                setError("Failed to fetch data.");
            }
            setLoading(false);
        };

        fetchData();
    }, [selectedCompany]);

    // if (!selectedCompany) return <p className={style.message}>Please select a company to view details.</p>;
    // if (loading) return <p className={style.loading}>Loading company details...</p>;
    if (error) return <p className={style.error}>{error}</p>;

    return (
        <div className={style.fundamentalContainer}>
            {companyData ? (
                <>
                    {/* Company Name and Price Section */}
                    <h2 className={style.companyName}>
                        {companyData.COMPNAME || "N/A"}
                        <span className={style.priceSection}>
                            ₹<strong>{livePrice?.CLOSE ? Math.floor(livePrice.CLOSE) : "N/A"}</strong>
                            {/* Show percentage change from open price */}
                            {openChange !== null && (
                                <span className={`${style.priceChange} ${openChange >= 0 ? style.up : style.down}`}>
                                    {openChange >= 0 ? "▲" : "▼"} {Math.abs(openChange)}%
                                </span>
                            )}
                        </span>
                    </h2>

                    {/* Company Information Grid */}
                    <div className={style.gridContainer}>
                        <div className={style.gridItem}><p>Scrip Name:</p> <strong>         {companyData.SCRIP_NAME || "N/A"} </strong> </div>
                        <div className={style.gridItem}><p>Symbol:</p> <strong>         {companyData.SYMBOL || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>Industry:</p> <strong>         {companyData.industry || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>Chairman:</p><strong>          {companyData.CHAIRMAN || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>Managing Director:</p> <strong>         {companyData.MDIR || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>Face Value (FV):</p> <strong>         {companyData.FV || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>ISIN:</p> <strong>         {companyData.ISIN || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>CIN:</p> <strong>         {companyData.CIN || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>Financial Code:</p> <strong>         {companyData.FINCODE || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>Status:</p> <strong>  {companyData.Status || "N/A"}  </strong> </div>
                        <div className={style.gridItem}><p>Incorporation:</p> <strong>         {companyData.INC_MONTH || "N/A"}-{companyData.INC_YEAR || "N/A"}  </strong> </div>

                    </div>

                    {/* Live Market Data */}
                    {livePrice ? (
                        <div className={style.livePriceContainer}>
                            <h3 className={style.livePriceHeader}>Live Market Data</h3>
                            <div className={style.gridContainer}>
                                <div className={style.gridItem}><p>Current Price:</p> <strong>         ₹{livePrice.CLOSE || "N/A"} </strong></div>
                                <div className={style.gridItem}><p>Open Price:</p><strong>          ₹{livePrice.OPEN || "N/A"} </strong></div>
                                <div className={style.gridItem}><p>High / Low</p> <strong>         ₹{livePrice.HIGH || "N/A"} / {livePrice.LOW || "N/A"} </strong></div>
                                <div className={style.gridItem}><p>Previous Close:</p><strong>          ₹{livePrice.PREVCLOSE || "N/A"} </strong></div>
                                <div className={style.gridItem}><p>Volume:</p> <strong>         {livePrice.VOLUME || "N/A"} </strong></div>
                            </div>
                        </div>
                    ) : (
                        <p className={style.noLivePrice}></p>
                    )}
                </>
            ) : (
                <p className={style.message}></p>
            )}
        </div>
    );
};

export default Fundamental;
